module.exports = __webpack_public_path__ + "img/datos-abiertos.ea2d9164.png";